import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
    page: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
    },
    investImage: {
        marginBottom: 25,
    },
    title: {
        fontSize: 22,
        color: '#000006',
        fontFamily: 'Montserrat',
        marginBottom: 35,
        fontWeight: '900',
    },
});
